import { Dispatch, useEffect, useReducer, useRef } from 'react';
import { Action, FetchReducer, FetchState, fetchReducer } from 'src/reducers/fetchReducer';

const useSafeReducer = <T>(initialState: FetchState<T>): [FetchState<T>, Dispatch<Action<T>>] => {
  const ref = useRef({ isMounted: true });
  const [state, dispatch] = useReducer<FetchReducer<T>>(fetchReducer, initialState);

  const cleanup = () => {
    ref.current.isMounted = false;
  };

  const safeDispatch = (value: Action<T>) => {
    if (ref.current.isMounted) {
      dispatch(value);
    }
  };

  // cleanup on unmount
  useEffect(() => cleanup, []);

  return [state, safeDispatch];
};

export default useSafeReducer;
